import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SecurityService} from '../../../components/security';
import {
    SubscriptionStreamingService,
    SubscriptionSubject
} from '../../../components/streaming/subscription-streaming.service';
import {Quote} from './quote';
import {QuotesSubscriptionSubject} from './quotes-subscription-subject';

@Injectable()
export class QuotesStreamingService {

    private readonly subjectTypeByAggregation: {[aggregationScale: number]: QuotesSubscriptionSubject} = {};

    constructor(
        protected subscriptionStreamingService: SubscriptionStreamingService,
        protected securityService: SecurityService
    ) {}

    public createSubscription(subject: SubscriptionSubject, aggregationScale: number = 1): Observable<Quote> {
        const subjectDict = this.subjectTypeByAggregation;
        const quotesSubscriptionSubject = subjectDict[aggregationScale] = subjectDict[aggregationScale]
            || new QuotesSubscriptionSubject(aggregationScale, this.securityService);

        return this.subscriptionStreamingService.createSubscription(
            quotesSubscriptionSubject.type,
            subject
        );
    }

}
